import { PaymentTransactionTypeEnum } from "./V2/gozer"

export const PaymentTypes = [
    {
        name: "Payment",
        paymentTransactionType: PaymentTransactionTypeEnum.CHARGE
    },
    {
        name: "ACH Return",
        paymentTransactionType: PaymentTransactionTypeEnum.ACHRETURN
    },
    {
        name: "Chargeback",
        paymentTransactionType: PaymentTransactionTypeEnum.CHARGEBACK
    },
    {
        name: "Void",
        paymentTransactionType: PaymentTransactionTypeEnum.VOID
    },
    {
        name: "Refund",
        paymentTransactionType: PaymentTransactionTypeEnum.REFUND
    },
    {
        name: "Transfer",
        paymentTransactionType: PaymentTransactionTypeEnum.REVERSAL
    }
].sort((a,b) => a?.name?.localeCompare(b?.name ?? "") ?? 0)